import { Switch } from 'react-router-dom';
import { TimeoutContainer, PageRoute } from 'shared/components';
import IncorrectPinContainer from '../shared/components/ReviewApp/containers/IncorrectPinContainer';
import NoCreditContainer from '../shared/components/ReviewApp/containers/NoCreditContainer';
import UnderwritingContainer from '../shared/components/ReviewApp/containers/UnderwritingContainer';
import AppReviewContainer from '../shared/components/ReviewApp/containers/AppReviewContainer';
import DelinquencyReviewContainer from '../shared/components/ReviewApp/containers/DelinquencyReviewContainer';

// eslint-disable-next-line import/no-anonymous-default-export
export default () => (
  <Switch>
    <PageRoute path="/applications/:uuid/review-app/incorrect-pin">
      <IncorrectPinContainer />
    </PageRoute>
    <PageRoute path="/applications/:uuid/review-app/no-credit">
      <NoCreditContainer />
    </PageRoute>
    <PageRoute path="/applications/:uuid/review-app/uw">
      <UnderwritingContainer />
    </PageRoute>
    <PageRoute path="/applications/:uuid/review-app/app-review">
      <AppReviewContainer />
    </PageRoute>
    <PageRoute path="/applications/:uuid/review-app/delinquency">
      <DelinquencyReviewContainer />
    </PageRoute>

    {[
      { path: '/applications/:uuid/review-app/signdocs', key: 'signdocs' },
      { path: '/applications/:uuid/review-app/in-review', key: 'in-review' },
      { path: '/applications/:uuid/review-app/timeout', key: 'timeout' },
    ].map(({ path, key }) => (
      <PageRoute path={path} key={key}>
        <TimeoutContainer />
      </PageRoute>
    ))}
  </Switch>
);
